import React, { SyntheticEvent, useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { Button, DropdownProps,  Grid,  Input,  InputOnChangeData,  Pagination, PaginationProps, Table } from "semantic-ui-react";
import { history } from "../..";
import agent from "../../app/api/agent";
import { _DrawType2DOptions, _RowPerPageOptions } from "../../app/lib/CommonData";
import { _GetRowPerPage, _SetRowPerPage } from "../../app/lib/CommonFunctions";
import Draw2DLink from "../../app/lib/draw2dlink";
import LoadingComponent from "../../app/lib/LoadingComponent";
import MyDropDown from "../../app/lib/MyDropDown";
import MyTableWithSort from "../../app/lib/MyTableWithSort";
import NumberStatus from "../../app/lib/NumberStatus";
import { Analysis3DResult } from "../../app/models/IDayResult";
import { useStore } from "../../app/store/store";
import HelpAnalysis2D from "./HelpAnalysis2D";


export default function Analysis2D(){
    const [column, setColumn] = useState("NoOfHit");
    const [direction, setDirection] = useState<"ascending" | "descending" | undefined>("descending");
    const [page, setPage] = useState(1);

    const [loading, setLoading] = useState(true);
    const [drawType, setDrawType] = useState("AB");
    const [analysis, setAnalysis] = useState<Analysis3DResult[]>([]);
    const [rowPerPage, setRowPerPage] = useState(_GetRowPerPage());
    const {userStore, modalStore} = useStore();

    if(!userStore.isLogged){
      history.push("/");
    }

    const rowPerPageChanged = (e: SyntheticEvent<any, Event>, option: DropdownProps)=>{
      setPage(1);
      setRowPerPage(parseInt(option.value + ""));
      _SetRowPerPage(parseInt(option.value + ""));
      //setLoading(true);
     
    }

    
   const handleColumnClick = (columnName : string)=>{

     if (column !== columnName){
       setDirection("ascending");
     }
     else{
       if (direction === undefined){
         setDirection('ascending');
       }
       else{
         setDirection(direction === "ascending" ? "descending" : "ascending");
       }
     }
     setColumn(columnName);
   }

   const handlePageChanged = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: PaginationProps)=>{
     setPage(parseInt(data.activePage!.toString()));
   }

   const handleDropDownSelect = (e: SyntheticEvent<any, Event>, option: DropdownProps)=>{
    //setPage(1);
        setDrawType(option.value + "");
    
    }

    const handleInputChanged = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData)=>{
      if(data.value.length === 3){
          if (!isNaN(parseFloat(data.value))){
            let newDirection:string;

            newDirection = "";
            if (direction === "ascending"){
              newDirection = "asc";
            }
            if (direction === "descending"){
              newDirection = "desc";
            }
            agent.Draw4DResult.getPageBy2DNumber(data.value, column, newDirection, drawType, rowPerPage).then(response=>{
              if(response.pageNo === 0){
                toast.error("Number not found ! Check the Draw Type.");
                return;
              }  
              toast.info("Found number in row " + response.row_No);

              setPage(response.pageNo);
            });
          }
      }

    }

    useEffect(()=>{

        let newDirection = "";
        if (direction === "ascending"){
            newDirection = "asc";
        }
        if (direction === "descending"){
            newDirection = "desc";
        }
        
        
        agent.Draw4DResult.getAnalysis2D(drawType, column, newDirection , page, rowPerPage).then((response)=>{

            setAnalysis(response);
            setLoading(false);
            
        });


    },[drawType, column, direction, page, rowPerPage]);

    const openHelp = () =>{
      modalStore.openModal(<HelpAnalysis2D></HelpAnalysis2D>, "2D-3D-4D","fullscreen", null,()=>{})
    }

    if (loading){
        return (<LoadingComponent></LoadingComponent>); 
    }
    return (
          <div style={{overflowX:"auto"}}>
            <Table celled  sortable unstackable className="freeze-head-and-col">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell colSpan="12" textAlign="center">
                <Button size="small"  data-tooltip="Training Video" data-position="bottom center" positive icon="video" onClick={()=>{openHelp()}}></Button>
                <span style={{marginLeft:"10px", fontSize : "22px", fontWeight: "bold", verticalAlign:"middle"}}>{`2D - 3D - 4D`}</span>
                </Table.HeaderCell>
              </Table.Row>
              <Table.Row>
                <Table.HeaderCell colSpan="12" textAlign="left">
                <Grid centered divided columns={4}>
                  <Grid.Column textAlign="left" verticalAlign="middle">
                    <MyDropDown zIndex="20"
                        toolTip = "Select Draw Type"
                        onChange = {handleDropDownSelect}
                        placeholder='Select Draw Type'
                        options={_DrawType2DOptions}
                        defaultValue = {drawType}>
                    </MyDropDown>
                  </Grid.Column>

                  <Grid.Column verticalAlign="middle">
                    <Input data-position="bottom center" fluid maxLength={3} focus placeholder='Search 2D position in the list' data-tooltip="Search 2D position in the list"  onChange={handleInputChanged}></Input>
                  </Grid.Column>
                  <Grid.Column verticalAlign="middle">
                  <MyDropDown zIndex="20"
                      placeholder="Select Item Per Page"
                      toolTip="Select Item Per Page" 
                      onChange = {rowPerPageChanged}
                      options={_RowPerPageOptions}
                      defaultValue={rowPerPage} >
                  </MyDropDown>
                </Grid.Column>

                  <Grid.Column verticalAlign="middle">
                  2D Analysis
                  </Grid.Column>
                </Grid>
                </Table.HeaderCell>
              </Table.Row>
              <Table.Row>
                  <MyTableWithSort rowSpan={2} textAlign="center" direction={direction} column={column} columnName="permutated_number" handleClick={handleColumnClick}>
                    System<br/>2D
                  </MyTableWithSort> 
                  <Table.HeaderCell rowSpan={2} textAlign="center">#</Table.HeaderCell>
                  <MyTableWithSort rowSpan={2} textAlign="center" direction={direction} column={column} columnName="NoOfHit" handleClick={handleColumnClick}>
                    Strike<br/>(ALL)
                  </MyTableWithSort>
                  <MyTableWithSort rowSpan={2} textAlign="center" direction={direction} column={column} columnName="hitCount123" handleClick={handleColumnClick}>
                    Strike<br/>(TOP3)
                  </MyTableWithSort> 
                  <MyTableWithSort rowSpan={2} textAlign="center" direction={direction} column={column} columnName="interval" handleClick={handleColumnClick}>
                    System<br/>Interval
                  </MyTableWithSort> 
                  <MyTableWithSort  rowSpan={2} textAlign="center" direction={direction} column={column} columnName="interval123" handleClick={handleColumnClick}>
                    Top3<br/>Interval
                  </MyTableWithSort> 
                  <MyTableWithSort  rowSpan={2} textAlign="center" direction={direction} column={column} columnName="systemInRange" handleClick={handleColumnClick}>
                    System<br/>In Range
                  </MyTableWithSort>
                  <MyTableWithSort  rowSpan={2} textAlign="center" direction={direction} column={column} columnName="top3Inrange" handleClick={handleColumnClick}>
                    Top3<br/>In Range
                  </MyTableWithSort>
                  <Table.HeaderCell colSpan={4} textAlign="center">
                      Rank (10 Years 2D)
                  </Table.HeaderCell>
             </Table.Row>
             <Table.Row>
                  <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="All_Rank" handleClick={handleColumnClick}>
                    All<br/>Rank
                  </MyTableWithSort>
                  <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Top3_Rank" handleClick={handleColumnClick}>
                    Top3<br/>Rank
                  </MyTableWithSort>
                  <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="all_Rank_Month" handleClick={handleColumnClick}>
                    All Rank<br/>By Month
                  </MyTableWithSort>
                  <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Top3_Rank_Month" handleClick={handleColumnClick}>
                    Top3<br/>By Month
                  </MyTableWithSort>

             </Table.Row>
            </Table.Header>
            <Table.Body>
                {analysis && analysis.length > 0 && analysis.map((x => {
                    return (
                        <Table.Row key={x.draw_ID}>
                            <Table.Cell textAlign="center">
                              <Draw2DLink title = ""  number={x.permutated_Number}></Draw2DLink>
                            </Table.Cell>

                          <Table.Cell textAlign="center">{x.draw_ID}</Table.Cell>
                            <Table.Cell  textAlign="right">{x.noOfHit}</Table.Cell>
                            <Table.Cell  textAlign="right">{x.hitCount123}</Table.Cell>

                            <Table.Cell  textAlign="right">{x.interval}</Table.Cell>
                            <Table.Cell  textAlign="right">{x.interval123}</Table.Cell>
                            <Table.Cell  textAlign="center">
                                <NumberStatus status={x.systemInRange} />
                            </Table.Cell>
                            <Table.Cell  textAlign="center">
                                <NumberStatus status={x.top3InRange} />
                            </Table.Cell>
                            <Table.Cell  textAlign="right">{x.all_Rank}</Table.Cell>
                            <Table.Cell  textAlign="right">{x.top3_Rank}</Table.Cell>
                            <Table.Cell  textAlign="right">{x.all_Rank_Month}</Table.Cell>
                            <Table.Cell  textAlign="right">{x.top3_Rank_Month}</Table.Cell>
                        </Table.Row>
                    )
                }))}
            </Table.Body>
            </Table>
            <Pagination activePage={page} totalPages={analysis && analysis.length > 0 ? analysis[0].totalPage : 10} onPageChange={handlePageChanged}/>
        </div>              
    );
}